import * as React from 'react';
import { remote } from '@code-expert/prelude';
export const useTrigger = (r) => {
    const state = React.useRef(0);
    if (remote.isDone(r)) {
        state.current = r.value;
    }
    return state.current;
};
//# sourceMappingURL=trigger.js.map